import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './MenuModule.css'
import { userLoggedOut } from '../../../redux/actions';
import { Link, withRouter } from 'react-router-dom';
import LogoAVL from '../../../logo_avl.png';
import Competitor from '../../../assets/Competitor.png';
import SalesReturn from '../../../assets/SalesReturn.png';
import axios from 'axios';
import { connect } from 'react-redux';
import FadeLoader from "react-spinners/FadeLoader";
import ReactTooltip from "react-tooltip";
import { faBars, faShoppingCart, faRupeeSign, faExclamationTriangle, faFileAlt, faChartLine, faBolt, faAssistiveListeningSystems, faCogs, faRoute, faMapMarkerAlt, faMapMarkedAlt, faUniversalAccess, faChartBar, faCalendarAlt, faFileInvoiceDollar, faCartArrowDown, faFileInvoice, faHandHoldingUsd, faSitemap, faCartPlus, faLayerGroup, faSync, faBoxOpen, faSyncAlt, faUser, faPiggyBank, faBalanceScale, faMoneyBillAlt, faHandsHelping, faPaste, faSearchLocation, faMoneyCheckAlt, faWarehouse, faSortAmountUp, faUserShield, faPeopleCarry, faLuggageCart, faProjectDiagram, faUsers, faDolly, faTasks, faSearchDollar, faLandmark, faDigitalTachograph, faChalkboardTeacher, faDatabase, faUserTag, faRedoAlt, faImage, faPhotoVideo, faCommentsDollar, faFileImport, faChevronDown, faChevronRight, faPowerOff } from "@fortawesome/free-solid-svg-icons";

// import { hashHistory  } from 'react-router';

class MenuModule extends Component {

    constructor(props) {
        super(props)

        this.state = {
            expandedMenus: {},
            httpURL: this.props.httpURL,
            loginuserObj: this.props.userObj,
            menuList: [],
            loading: false,
            hoveredMenu: null,
            sidebarHover: false
        }
        this.menuRefs = {};
    }

    componentDidMount() {
        this.getMMMenuList();
        this.updateBodySidebarClass();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.toggleActive !== this.props.toggleActive || prevState.sidebarHover !== this.state.sidebarHover) {
            this.updateBodySidebarClass();
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('sidebar-collapsed');
        document.body.classList.remove('sidebar-expanded');
    }

    updateBodySidebarClass = () => {
        const collapsed = this.props.toggleActive && !this.state.sidebarHover;
        if (collapsed) {
            document.body.classList.add('sidebar-collapsed');
            document.body.classList.remove('sidebar-expanded');
        } else {
            document.body.classList.remove('sidebar-collapsed');
            document.body.classList.add('sidebar-expanded');
        }
    }

    getMMMenuList() {
        let utype = this.state.loginuserObj.userType;
        const params = {
            userType: utype,
        }
        this.setState({
            loading: true
        });
        axios.get(this.state.httpURL + "/user/getMMMenuList", { params })
            .then(response => response.data)
            .then((data) => {
                if (data.valid) {
                    this.setState({
                        menuList: data.menuList
                    })

                    ReactTooltip.rebuild();
                } else {
                    alert(data.responseMsg);
                }
                this.setState({
                    loading: false
                });
            }).catch(err => {
                //console.log(err)
                this.setState({
                    loading: false
                });
                alert(err);
            })
    }

    toggleSubmenu = (menuKey) => {
        this.setState(prevState => ({
            expandedMenus: {
                ...prevState.expandedMenus,
                [menuKey]: !prevState.expandedMenus[menuKey]
            }
        }));
    }

    // Helper method to check if menu item exists in menuList
    hasMenuItem = (displayName) => {
        return this.state.menuList.some(menu => menu.displayName === displayName);
    }

    isActiveRoute = (path) => {
        const { location } = this.props;
        return location && location.pathname === path;
    }

    // Helper method to render menu item
    renderMenuItem = (icon, label, to) => {
        const { toggleActive } = this.props;
        const collapsed = toggleActive && !this.state.sidebarHover;
        const isActive = this.isActiveRoute(to);
        return (
            <Link to={to} className={`menu-item ${isActive ? 'active' : ''}`} data-tooltip={label}>
                <div className="menu-item-content">
                    <FontAwesomeIcon icon={icon} className="menu-icon" />
                    <span className={`menu-label ${collapsed ? 'collapsed-hidden' : ''}`}>{label}</span>
                </div>
            </Link>
        );
    }

    // Helper method to render submenu item
    renderSubMenuItem = (icon, label, to) => {
        const { toggleActive } = this.props;
        const collapsed = toggleActive && !this.state.sidebarHover;
        const isActive = this.isActiveRoute(to);
        return (
            <Link to={to} className={`submenu-item ${isActive ? 'active' : ''}`} data-tooltip={label}>
                <div className="submenu-item-content">
                    <FontAwesomeIcon icon={icon} className="submenu-icon" />
                    <span className={`submenu-label ${collapsed ? 'collapsed-hidden' : ''}`}>{label}</span>
                </div>
            </Link>
        );
    }

    // Helper method to render expandable menu section
    renderExpandableMenu = (key, icon, label, children) => {
        const { toggleActive } = this.props;
        const { expandedMenus } = this.state;
        const isExpanded = expandedMenus[key];
        if (!this.menuRefs[key]) this.menuRefs[key] = React.createRef();
        const isHovered = this.state.hoveredMenu === key;
        const collapsed = toggleActive && !this.state.sidebarHover;
        const showFlyout = collapsed && isHovered;

        let flyoutTop = 0;
        try {
            const el = this.menuRefs[key].current;
            if (el) {
                const rect = el.getBoundingClientRect();
                flyoutTop = rect.top;
            }
        } catch (e) {}
        const flyoutLeft = collapsed ? 64 : 256;

        return (
            <div className="menu-section" ref={this.menuRefs[key]} onMouseEnter={() => this.setState({hoveredMenu: key})} onMouseLeave={() => this.setState({hoveredMenu: null})}>
                <div
                    className={`menu-item expandable ${isExpanded ? 'expanded' : ''}`}
                    onClick={() => this.toggleSubmenu(key)}
                    data-tooltip={label}
                >
                    <div className="menu-item-content">
                        <FontAwesomeIcon icon={icon} className="menu-icon" />
                        <span className={`menu-label ${collapsed ? 'collapsed-hidden' : ''}`}>{label}</span>
                        {!collapsed && (
                            <FontAwesomeIcon
                                icon={isExpanded ? faChevronDown : faChevronRight}
                                className="expand-icon"
                            />
                        )}
                    </div>
                </div>
                {isExpanded && !collapsed && (
                    <div className="submenu-container">
                        {children}
                    </div>
                )}

                {showFlyout && (
                    <div className="flyout-submenu" style={{ top: flyoutTop + 'px', left: flyoutLeft + 'px' }} onMouseEnter={() => this.setState({hoveredMenu: key})} onMouseLeave={() => this.setState({hoveredMenu: null})}>
                        <div className="flyout-inner">
                            {children}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    logOut = () => {
        if (this.props.logoutflag) {
            // Reuse the exact same logout flow provided by AppBody -> TopModule
            this.props.logoutflag();
        } else {
            // fallback to dispatching Redux logout action
            this.props.userLoggedOut();
        }
    };

    openChangePassword = () => {
        const el = document.querySelector('.Changepswd_wrapper');
        if (el) el.style.display = 'flex';
    }

    render() {
        const { toggleActive } = this.props;
        const { menuList, loading } = this.state;
        const collapsed = toggleActive && !this.state.sidebarHover;

        if (loading) {
            return (
                <nav className="sidebar">
                    <div className="sidebar-loading">
                        <FadeLoader color="#2563EB" />
                    </div>
                </nav>
            );
        }

        return (
            <nav className={`sidebar ${collapsed ? 'collapsed' : 'expanded'}`} onMouseEnter={() => { if (this.props.toggleActive) this.setState({sidebarHover: true}) }} onMouseLeave={() => { if (this.props.toggleActive) this.setState({sidebarHover: false}) }}>
                
                {/* Sidebar Header with Logo and Title */}
                <div className="sidebar-header" data-tooltip="Dashboard">
                    <img src={LogoAVL} alt="Logo" className="sidebar-logo-image" />
                    <div className="sidebar-title">Aravind Labs</div>
                </div>

                {/* Menu Items */}
                <div className="sidebar-content">
                    {/* Main Menu Items */}
                    {this.hasMenuItem('Order') && this.renderMenuItem(faShoppingCart, 'Order', '/order')}
                    {this.hasMenuItem('Collection') && this.renderMenuItem(faRupeeSign, 'Collection', '/collection')}
                    {this.hasMenuItem('SalesReturn') && this.renderMenuItem(faCartArrowDown, 'Sales Return', '/salesReturn')}
                    {this.hasMenuItem('NewRetailer') && this.renderMenuItem(faFileAlt, 'New Retailer', '/newCustomer')}
                    {this.hasMenuItem('View BA Sales') && this.renderMenuItem(faFileAlt, 'View BA Sales', '/viewBASales')}
                    {this.hasMenuItem('Competitor') && (
                        <div className="menu-item">
                            <div className="menu-item-content">
                                <img src={Competitor} alt="Competitor" className="menu-icon" />
                                {!collapsed && <span className="menu-label">Competitors</span>}
                            </div>
                        </div>
                    )}
                    {this.hasMenuItem('RoleAccess') && this.renderMenuItem(faUserShield, 'Role Access', '/roleAccess')}
                    {this.hasMenuItem('Menu Maintenance') && this.renderMenuItem(faBars, 'Menu Maintenance', '/menuMaintenance')}
                    {this.hasMenuItem('View Photo') && this.renderMenuItem(faPhotoVideo, 'View Photo', '/viewPhoto')}
                    {this.hasMenuItem('Expenses View') && this.renderMenuItem(faCommentsDollar, 'Expenses View', '/expensesView')}

                    {/* Distributors Submenu */}
                    {(this.hasMenuItem('Distributors') || this.hasMenuItem('Distributor') || this.hasMenuItem('Distributor Stock')) && this.renderExpandableMenu(
                        'distributors',
                        faSitemap,
                        'Distributors',
                        <>
                            {this.hasMenuItem('Distributor') && this.renderSubMenuItem(faSitemap, 'Distributor', '/distributor')}
                            {this.hasMenuItem('Distributor Stock') && this.renderSubMenuItem(faCartPlus, 'Distributor Stock', '/distributorStock')}
                        </>
                    )}

                    {/* Reports Submenu */}
                    {(this.hasMenuItem('Reports') || this.hasMenuItem('Dsr Reports') || this.hasMenuItem('ERP Uploaded Order') || this.hasMenuItem('Visit Detail') || this.hasMenuItem('Sale Order Detail') || this.hasMenuItem('UserAppVersion') || this.hasMenuItem('SalesReport') || this.hasMenuItem('Activity Report') || this.hasMenuItem('Retailer Report') || this.hasMenuItem('Upload Sales Data') || this.hasMenuItem('User Attendance') || this.hasMenuItem('BA Attendance')) && this.renderExpandableMenu(
                        'reports',
                        faChartBar,
                        'Reports',
                        <>
                            {this.hasMenuItem('Dsr Reports') && this.renderSubMenuItem(faChartLine, 'DSR', '/reports')}
                            {this.hasMenuItem('ERP Uploaded Order') && this.renderSubMenuItem(faSortAmountUp, 'ERP Uploaded Order', '/erpUploadedOrder')}
                            {this.hasMenuItem('Visit Detail') && this.renderSubMenuItem(faLandmark, 'Visit Detail', '/visitDetail')}
                            {this.hasMenuItem('Sale Order Detail') && this.renderSubMenuItem(faLandmark, 'Sale Order Detail', '/SaleOrderDetailReport')}
                            {this.hasMenuItem('UserAppVersion') && this.renderSubMenuItem(faLandmark, 'User - App Version', '/UserAppVersionReport')}
                            {this.hasMenuItem('SalesReport') && this.renderSubMenuItem(faLandmark, 'Order and BA order Sales Details', '/SalesReportOnDemandReport')}
                            {this.hasMenuItem('Activity Report') && this.renderSubMenuItem(faChartLine, 'Activity Report', '/ActivityReports')}
                            {this.hasMenuItem('Retailer Report') && this.renderSubMenuItem(faChartLine, 'Retailer Report', '/RetailerReport')}
                            {this.hasMenuItem('Upload Sales Data') && this.renderSubMenuItem(faChartLine, 'Upload Sales Data', '/uploadSalesData')}
                            {this.hasMenuItem('User Attendance') && this.renderSubMenuItem(faChartLine, 'User Attendance', '/userAttendance')}
                            {this.hasMenuItem('BA Attendance') && this.renderSubMenuItem(faChartLine, 'BA Attendance', '/baAttendance')}
                        </>
                    )}

                    {/* Masters Submenu */}
                    {(this.hasMenuItem('Masters') || this.hasMenuItem('SalesmanRoute') || this.hasMenuItem('Visit plan') || this.hasMenuItem('RouteMaster') || this.hasMenuItem('Salesman') || this.hasMenuItem('DayMaster') || this.hasMenuItem('Product') || this.hasMenuItem('Product Price') || this.hasMenuItem('Retailer Price') || this.hasMenuItem('Distributor Price Margin') || this.hasMenuItem('Product Group') || this.hasMenuItem('Product Type') || this.hasMenuItem('Generate Scheme') || this.hasMenuItem('Maintain Scheme') || this.hasMenuItem('User') || this.hasMenuItem('User Role') || this.hasMenuItem('User Team') || this.hasMenuItem('Meta Data') || this.hasMenuItem('BA Retailer') || this.hasMenuItem('BA Retailer Outlet') || this.hasMenuItem('DataSync') || this.hasMenuItem('State And City') || this.hasMenuItem('Retailer Approval') || this.hasMenuItem('Retailer Team Allocation')) && this.renderExpandableMenu(
                        'masters',
                        faLayerGroup,
                        'Masters',
                        <>
                            {this.hasMenuItem('SalesmanRoute') && this.renderSubMenuItem(faRoute, 'Salesman Route', '/salesmanRoute')}
                            {this.hasMenuItem('Visit plan') && this.renderSubMenuItem(faPeopleCarry, 'Visit Plan', '/visitPlan')}
                            {this.hasMenuItem('RouteMaster') && this.renderSubMenuItem(faMapMarkedAlt, 'Route Master', '/routeMaster')}
                            {this.hasMenuItem('Salesman') && this.renderSubMenuItem(faUniversalAccess, 'Salesman', '/salesman')}
                            {this.hasMenuItem('DayMaster') && this.renderSubMenuItem(faCalendarAlt, 'Day Master', '/dayMaster')}
                            {this.hasMenuItem('Product') && this.renderSubMenuItem(faCartArrowDown, 'Product', '/product')}
                            {this.hasMenuItem('Product Price') && this.renderSubMenuItem(faFileInvoice, 'Product Price', '/productPrice')}
                            {this.hasMenuItem('Retailer Price') && this.renderSubMenuItem(faHandHoldingUsd, 'Retailer Price', '/retailerPrice')}
                            {this.hasMenuItem('Distributor Price Margin') && this.renderSubMenuItem(faFileInvoice, 'Distributor Price Margin', '/distributorPriceMargin')}
                            {this.hasMenuItem('Product Group') && this.renderSubMenuItem(faSitemap, 'Product Group', '/productGroup')}
                            {this.hasMenuItem('Product Type') && this.renderSubMenuItem(faBoxOpen, 'Product Type', '/productType')}
                            {this.hasMenuItem('Generate Scheme') && this.renderSubMenuItem(faChalkboardTeacher, 'Generate Scheme', '/schemeGenerate')}
                            {this.hasMenuItem('Maintain Scheme') && this.renderSubMenuItem(faProjectDiagram, 'Maintain Scheme', '/schemeMaintain')}
                            {this.hasMenuItem('User') && this.renderSubMenuItem(faUsers, 'User', '/userAccess')}
                            {this.hasMenuItem('User Role') && this.renderSubMenuItem(faUserTag, 'User Role', '/userRoleModule')}
                            {this.hasMenuItem('User Team') && this.renderSubMenuItem(faUserTag, 'User Team', '/userTeamModule')}
                            {this.hasMenuItem('Meta Data') && this.renderSubMenuItem(faDatabase, 'Meta Data', '/metaDataModule')}
                            {this.hasMenuItem('BA Retailer') && this.renderSubMenuItem(faFileAlt, 'BA Retailer', '/baRetailer')}
                            {this.hasMenuItem('BA Retailer Outlet') && this.renderSubMenuItem(faFileAlt, 'BA Retailer Outlet', '/baRetailerOutLet')}
                            {this.hasMenuItem('DataSync') && this.renderSubMenuItem(faSync, 'Data Sync', '/dataSync')}
                            {this.hasMenuItem('State And City') && this.renderSubMenuItem(faMapMarkedAlt, 'State and City', '/cityState')}
                            {this.hasMenuItem('Retailer Approval') && this.renderSubMenuItem(faMapMarkedAlt, 'Retailer Approval', '/retailerApproval')}
                            {this.hasMenuItem('Retailer Team Allocation') && this.renderSubMenuItem(faMapMarkedAlt, 'Retailer Team Allocation', '/retailerTeamAllocation')}
                        </>
                    )}

                    {/* Price Submenu */}
                    {this.hasMenuItem('Price') && this.renderExpandableMenu(
                        'price',
                        faSearchDollar,
                        'Price',
                        <>
                            {this.renderSubMenuItem(faFileInvoiceDollar, 'Price Type', '/priceType')}
                        </>
                    )}

                    {/* View Data Sync Submenu */}
                    {(this.hasMenuItem('ViewDataSync') || this.hasMenuItem('Client - Data Sync') || this.hasMenuItem('Organization - Data Sync') || this.hasMenuItem('User - Data Sync') || this.hasMenuItem('Bank - Data Sync') || this.hasMenuItem('Invoice - Data Sync') || this.hasMenuItem('UOM - Data Sync') || this.hasMenuItem('Product - Data Sync') || this.hasMenuItem('Business Partner - Data Sync') || this.hasMenuItem('Business Partner Location - Data Sync') || this.hasMenuItem('Document Type - Data Sync') || this.hasMenuItem('Location - Data Sync') || this.hasMenuItem('Payment Term - Data Sync') || this.hasMenuItem('Price List - Data Sync') || this.hasMenuItem('Warehouse - Data Sync')) && this.renderExpandableMenu(
                        'viewDataSync',
                        faSyncAlt,
                        'View Sync Data',
                        <>
                            {this.hasMenuItem('Client - Data Sync') && this.renderSubMenuItem(faCartPlus, 'Client', '/client')}
                            {this.hasMenuItem('Organization - Data Sync') && this.renderSubMenuItem(faExclamationTriangle, 'Organization', '/organization')}
                            {this.hasMenuItem('User - Data Sync') && this.renderSubMenuItem(faUser, 'User', '/user')}
                            {this.hasMenuItem('Bank - Data Sync') && this.renderSubMenuItem(faPiggyBank, 'Bank', '/bank')}
                            {this.hasMenuItem('Invoice - Data Sync') && this.renderSubMenuItem(faFileInvoice, 'Invoice', '/invoice')}
                            {this.hasMenuItem('UOM - Data Sync') && this.renderSubMenuItem(faBalanceScale, 'UOM', '/uom')}
                            {this.hasMenuItem('Product - Data Sync') && this.renderSubMenuItem(faCartArrowDown, 'Product View', '/productView')}
                            {this.hasMenuItem('Business Partner - Data Sync') && this.renderSubMenuItem(faHandsHelping, 'Business Partner', '/businessPartner')}
                            {this.hasMenuItem('Business Partner Location - Data Sync') && this.renderSubMenuItem(faMapMarkedAlt, 'Business Partner Location', '/businessPartnerLocation')}
                            {this.hasMenuItem('Document Type - Data Sync') && this.renderSubMenuItem(faPaste, 'Document Type', '/documentType')}
                            {this.hasMenuItem('Location - Data Sync') && this.renderSubMenuItem(faSearchLocation, 'Location', '/location')}
                            {this.hasMenuItem('Payment Term - Data Sync') && this.renderSubMenuItem(faMoneyCheckAlt, 'Payment Term', '/paymentTerm')}
                            {this.hasMenuItem('Price List - Data Sync') && this.renderSubMenuItem(faMoneyBillAlt, 'PriceList View', '/priceListView')}
                            {this.hasMenuItem('Warehouse - Data Sync') && this.renderSubMenuItem(faWarehouse, 'WareHouse', '/wareHouse')}
                        </>
                    )}

                    {/* MIS Reports Submenu */}
                    {(this.hasMenuItem('MIS Reports') || this.hasMenuItem('SalesmanReport') || this.hasMenuItem('ProductReport') || this.hasMenuItem('Usage Detail Report') || this.hasMenuItem('Usage Detail Summary Report') || this.hasMenuItem('Monthly Retailer Order Summary') || this.hasMenuItem('BA-USummaryReport') || this.hasMenuItem('BASalesByRetailerReport')) && this.renderExpandableMenu(
                        'misReports',
                        faChartBar,
                        'MIS Reports',
                        <>
                            {this.hasMenuItem('SalesmanReport') && this.renderSubMenuItem(faChartLine, 'Salesman Report', '/salesmanReport')}
                            {this.hasMenuItem('ProductReport') && this.renderSubMenuItem(faChartLine, 'Product Report', '/productReport')}
                            {this.hasMenuItem('Usage Detail Report') && this.renderSubMenuItem(faChartLine, 'Usage Detail Report', '/UsageDetailReport')}
                            {this.hasMenuItem('Usage Detail Summary Report') && this.renderSubMenuItem(faChartLine, 'Usage Detail Summary Report', '/UsageDetailSummaryReport')}
                            {this.hasMenuItem('Monthly Retailer Order Summary') && this.renderSubMenuItem(faChartLine, 'Monthly Retailer Order Summary', '/MonthlyRetailerOrderSummary')}
                            {this.hasMenuItem('BA-USummaryReport') && this.renderSubMenuItem(faChartLine, 'BA - Usage Detail Summary Report', '/BA-USummaryReport')}
                            {this.hasMenuItem('BASalesByRetailerReport') && this.renderSubMenuItem(faChartLine, 'BA - Sales By Retailer Report', '/BASalesByRetailerReport')}
                        </>
                    )}

                    {/* Tool Submenu */}
                    {(this.hasMenuItem('Tool') || this.hasMenuItem('ToolModule') || this.hasMenuItem('RetailerDistributor_Report') || this.hasMenuItem('RetailerRoute_Report')) && this.renderExpandableMenu(
                        'tool',
                        faFileImport,
                        'Tool',
                        <>
                            {this.hasMenuItem('ToolModule') && this.renderSubMenuItem(faFileImport, 'Import', '/toolModule')}
                            {this.hasMenuItem('RetailerDistributor_Report') && this.renderSubMenuItem(faFileImport, 'Retailer Not Assinged to Distributor', '/retailerDistributorReport')}
                            {this.hasMenuItem('RetailerRoute_Report') && this.renderSubMenuItem(faFileImport, 'Retailer Without Valid Route', '/retailerRouteReport')}
                        </>
                    )}
                </div>

                {/* Sidebar footer removed — Change Password & Logout moved to Top Nav profile menu */}
            </nav>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userObj: state.userObj,
        httpURL: state.httpURL
    }
}

const mapDispatchToProps = dispatch => ({
    userLoggedOut: () => dispatch(userLoggedOut())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MenuModule));